import classNames from "classnames";

import styles from "./switcher.module.scss";

interface SwitcherInterface {
  options: string[];
  currentOption: string;
  onChange: (val: string) => () => void;
  className?: string;
}

const Switcher = ({
  options,
  currentOption,
  onChange,
  className
}: SwitcherInterface) => {
  return (
    <div className={classNames(styles["wrapper"], className)}>
      {options.map((item) => (
        <div
          className={classNames(styles["wrapper-button"], {
            [styles["wrapper-button--active"]]: currentOption === item
          })}
          key={item}
          onClick={onChange(item)}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default Switcher;
